import { BaseComponent } from '../../base.component';
import { Component, Injector, AfterViewInit, OnDestroy } from '@angular/core';
import { ScrollEventHandlerService } from '../../../Services/scroll-event-handler/scroll-event-handler.service';
import { PagesDurationService } from 'src/app/Services/pages-duration/pages-duration.service';
declare global {
	interface Window {
		IntersectionObserver: any;
	}
}
@Component({
	template: '',
})
export class EventsComponent extends BaseComponent implements AfterViewInit, OnDestroy {
	gaLabel: string;

	private readonly DISPLAY_SUFFIX = '_Displayed';
	private readonly GA_PREFILL_ACTION_SUFFIX_INTO_WE_FOUND = '_prefill_Action';
	private readonly PREFILL_ACTION_SUFFIX_STANDARD = '_StandardPrefill_Edited';
	private readonly SPLUNK_PREFILL_ACTION_SUFFIX_INTO_WE_FOUND = '_InfoWeFound_Popup_Prefill_Edited';
	private readonly PREFILL_SUFFIX_STANDARD = '_StandardPrefill_Displayed';
	public scrollEventHandler: ScrollEventHandlerService;
	public pagesDurationService: PagesDurationService;

	constructor(injector: Injector) {
		super(injector);
		this.scrollEventHandler = injector.get(ScrollEventHandlerService);
		this.pagesDurationService = injector.get(PagesDurationService);
	}

	ngAfterViewInit(): void {
		let currPath = location.pathname.slice(1);
		if (this.gaLabel) {
			// delimeter | allows to add multiple scroll events to the same component
			let elemName = currPath === 'YourRates' ? `${this.control.name}_${this.control.id}` : this.control.name;
			if (this.gaLabel.includes('|')) {
				let multiEventCounter = 1;
				this.gaLabel.split('|').forEach((lbl) => {
					this.registerElemByScroll(lbl, currPath, elemName + multiEventCounter++);
				});
			} else {
				this.registerElemByScroll(this.gaLabel, currPath, elemName);
			}
		}
	}

	registerElemByScroll(label, currPath, elemName) {
		this.scrollEventHandler.registerDisplayOnScroll(
			this.elementRef.nativeElement,
			elemName,
			label + this.DISPLAY_SUFFIX,
			currPath
		);
	}

	reportEditedPrefillValue(): void {
		if (
			this.control.attributes &&
			this.control.attributes.reportEvent &&
			this.control.attributes.reportEvent.onPrefill
		) {
			if (this.control.controlType === 'InfoWeFoundMvp' || this.control.controlType === 'InfoWeFound') {
				this.splunkAnalyticsService.publishOnce(
					'SysEvent',
					this.gaLabel + this.SPLUNK_PREFILL_ACTION_SUFFIX_INTO_WE_FOUND
				);
			} else {
				//this.splunkAnalyticsService.publishOnce('SysEvent', this.gaLabel + this.PREFILL_ACTION_SUFFIX_STANDARD);
			}
		}
	}

	reportPrefill() {
		// this.splunkAnalyticsService.publishOnce('Display', this.gaLabel + this.PREFILL_SUFFIX_STANDARD);
	}

	getGaLabel(control): string {
		if (control.attributes && control.attributes.gaEventLabel) {
			return control.attributes.gaEventLabel;
		}

		if (control.attributes && control.attributes.label) {
			return control.attributes.label;
		}
		return control.name;
	}

	ngOnDestroy(): void {
		if (this.control) {
			this.scrollEventHandler.removeElem(this.elementRef.nativeElement, this.control.name);
		}
	}
}
